import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { QueryParamItem, QueryParamsService } from '../../core/services/query-params.service';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'sha-filter-text',
  templateUrl: 'filter-text.component.html',
  styleUrls: ['filter-text.component.css']
})
export class FilterTextComponent implements OnInit, OnDestroy {
  @Output() changed: EventEmitter<string>;
  @Input() routeName = 'ftext';

  currentFilterText: BehaviorSubject<string> = new BehaviorSubject('');
  subscription: Subscription;

  constructor(private queryParamsService: QueryParamsService) {
    this.changed = new EventEmitter<string>();
  }

  ngOnInit() {
    this.queryParamsService.observe(this.routeName).subscribe(item => this.filterTextChangedInRoute(item));
    this.subscription = this.currentFilterText.subscribe(item => this.changed.emit(item));
  }

  ngOnDestroy() {
    this.queryParamsService.destroy(this.routeName);
    this.subscription.unsubscribe();
  }

  filterTextChanged(event: any) {
    event.preventDefault();

    const newText: string = event.target.value;
    // console.log('FilterTextComponent - filterTextChanged ->', newText);

    const currentValue = this.currentFilterText.getValue();
    if (!currentValue && newText) {
      this.currentFilterText.next(newText);
      this.updateRoute();
    } else if (currentValue && currentValue !== newText) {
      this.currentFilterText.next(newText);
      this.updateRoute();
    }
  }

  filterTextChangedInRoute(queryParamItem: QueryParamItem) {
    // console.log('FilterTextComponent - filterTextChangedInRoute ->', queryParamItem);

    const newText = queryParamItem.value;
    const currentValue = this.currentFilterText.getValue();
    const isEmpty = !newText && currentValue;
    const isNew = !currentValue || currentValue !== newText;

    if (isEmpty || isNew) {
      this.currentFilterText.next(newText ? newText : '');
    }
  }

  private updateRoute() {
    const param = {};
    const filter = this.currentFilterText.getValue();
    param[this.routeName] = (filter) ? filter : '';
    // console.log('FilterTextComponent - updateRoute ->', filter, param);
    this.queryParamsService.navigateByQueryParams([param]);
  }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared/filter-text/filter-text.component.ts